// extracted by mini-css-extract-plugin
export default {"carousel":"OF-z"};